module.exports = __webpack_public_path__ + "static/CreateShop-449f635f360413d3fc2dfc03d9636e8f.png";